/* tslint:disable */
/* eslint-disable */
/**
 * K1 OpenAPI
 * API fuer die Nutzung der K1 REST-Schnittstelle
 *
 * The version of the OpenAPI document: 1.168.0-SNAPSHOT
 * Contact: diplan-backend@init.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorRest } from '../models';
// @ts-ignore
import type { UnterverfahrensteilschrittRest } from '../models';
/**
 * UnterverfahrensteilschrittResourceApi - axios parameter creator
 * @export
 */
export const UnterverfahrensteilschrittResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein optionaler Unterverfahrensteilschritt aktiviert werden.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum aktivieren eines Unterverfahrensteilschritt.
         * @param {string} planID PlanID vom Verfahren
         * @param {number} vtsDurchgang Durchgangsnummer vom VTS
         * @param {string} codeUvts Unterverfahrensteilschritt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAktiv: async (planID: string, vtsDurchgang: number, codeUvts: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('setAktiv', 'planID', planID)
            // verify required parameter 'vtsDurchgang' is not null or undefined
            assertParamExists('setAktiv', 'vtsDurchgang', vtsDurchgang)
            // verify required parameter 'codeUvts' is not null or undefined
            assertParamExists('setAktiv', 'codeUvts', codeUvts)
            const localVarPath = `/verfahren/{planID}/{vtsDurchgang}/unterverfahrensteilschritte/{codeUvts}/aktiv`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"vtsDurchgang"}}`, encodeURIComponent(String(vtsDurchgang)))
                .replace(`{${"codeUvts"}}`, encodeURIComponent(String(codeUvts)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein aktivierter optionaler Unterverfahrensteilschritt deaktiviert werden.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Deaktivieren eines Unterverfahrensteilschritts.
         * @param {string} planID PlanID vom Verfahren
         * @param {number} vtsDurchgang Durchgangsnummer vom VTS
         * @param {string} codeUvts Unterverfahrensteilschritt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setInAktiv: async (planID: string, vtsDurchgang: number, codeUvts: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('setInAktiv', 'planID', planID)
            // verify required parameter 'vtsDurchgang' is not null or undefined
            assertParamExists('setInAktiv', 'vtsDurchgang', vtsDurchgang)
            // verify required parameter 'codeUvts' is not null or undefined
            assertParamExists('setInAktiv', 'codeUvts', codeUvts)
            const localVarPath = `/verfahren/{planID}/{vtsDurchgang}/unterverfahrensteilschritte/{codeUvts}/inaktiv`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"vtsDurchgang"}}`, encodeURIComponent(String(vtsDurchgang)))
                .replace(`{${"codeUvts"}}`, encodeURIComponent(String(codeUvts)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnterverfahrensteilschrittResourceApi - functional programming interface
 * @export
 */
export const UnterverfahrensteilschrittResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnterverfahrensteilschrittResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein optionaler Unterverfahrensteilschritt aktiviert werden.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum aktivieren eines Unterverfahrensteilschritt.
         * @param {string} planID PlanID vom Verfahren
         * @param {number} vtsDurchgang Durchgangsnummer vom VTS
         * @param {string} codeUvts Unterverfahrensteilschritt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAktiv(planID: string, vtsDurchgang: number, codeUvts: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnterverfahrensteilschrittRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAktiv(planID, vtsDurchgang, codeUvts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnterverfahrensteilschrittResourceApi.setAktiv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein aktivierter optionaler Unterverfahrensteilschritt deaktiviert werden.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Deaktivieren eines Unterverfahrensteilschritts.
         * @param {string} planID PlanID vom Verfahren
         * @param {number} vtsDurchgang Durchgangsnummer vom VTS
         * @param {string} codeUvts Unterverfahrensteilschritt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setInAktiv(planID: string, vtsDurchgang: number, codeUvts: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnterverfahrensteilschrittRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setInAktiv(planID, vtsDurchgang, codeUvts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnterverfahrensteilschrittResourceApi.setInAktiv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UnterverfahrensteilschrittResourceApi - factory interface
 * @export
 */
export const UnterverfahrensteilschrittResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnterverfahrensteilschrittResourceApiFp(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein optionaler Unterverfahrensteilschritt aktiviert werden.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum aktivieren eines Unterverfahrensteilschritt.
         * @param {string} planID PlanID vom Verfahren
         * @param {number} vtsDurchgang Durchgangsnummer vom VTS
         * @param {string} codeUvts Unterverfahrensteilschritt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAktiv(planID: string, vtsDurchgang: number, codeUvts: string, options?: RawAxiosRequestConfig): AxiosPromise<UnterverfahrensteilschrittRest> {
            return localVarFp.setAktiv(planID, vtsDurchgang, codeUvts, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein aktivierter optionaler Unterverfahrensteilschritt deaktiviert werden.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Deaktivieren eines Unterverfahrensteilschritts.
         * @param {string} planID PlanID vom Verfahren
         * @param {number} vtsDurchgang Durchgangsnummer vom VTS
         * @param {string} codeUvts Unterverfahrensteilschritt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setInAktiv(planID: string, vtsDurchgang: number, codeUvts: string, options?: RawAxiosRequestConfig): AxiosPromise<UnterverfahrensteilschrittRest> {
            return localVarFp.setInAktiv(planID, vtsDurchgang, codeUvts, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnterverfahrensteilschrittResourceApi - object-oriented interface
 * @export
 * @class UnterverfahrensteilschrittResourceApi
 * @extends {BaseAPI}
 */
export class UnterverfahrensteilschrittResourceApi extends BaseAPI {
    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein optionaler Unterverfahrensteilschritt aktiviert werden.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
     * @summary Endpunkt zum aktivieren eines Unterverfahrensteilschritt.
     * @param {string} planID PlanID vom Verfahren
     * @param {number} vtsDurchgang Durchgangsnummer vom VTS
     * @param {string} codeUvts Unterverfahrensteilschritt
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnterverfahrensteilschrittResourceApi
     */
    public setAktiv(planID: string, vtsDurchgang: number, codeUvts: string, options?: RawAxiosRequestConfig) {
        return UnterverfahrensteilschrittResourceApiFp(this.configuration).setAktiv(planID, vtsDurchgang, codeUvts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein aktivierter optionaler Unterverfahrensteilschritt deaktiviert werden.</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
     * @summary Endpunkt zum Deaktivieren eines Unterverfahrensteilschritts.
     * @param {string} planID PlanID vom Verfahren
     * @param {number} vtsDurchgang Durchgangsnummer vom VTS
     * @param {string} codeUvts Unterverfahrensteilschritt
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnterverfahrensteilschrittResourceApi
     */
    public setInAktiv(planID: string, vtsDurchgang: number, codeUvts: string, options?: RawAxiosRequestConfig) {
        return UnterverfahrensteilschrittResourceApiFp(this.configuration).setInAktiv(planID, vtsDurchgang, codeUvts, options).then((request) => request(this.axios, this.basePath));
    }
}

